import { t } from 'Utils/localization/i18next';
import CONFIG from 'Config/settings';

/**
 * Returns the reverse of a string based on a defined separator.
 * @param {string} string - The string to be reversed.
 * @param {string} stringSeparator - The string separator.
 * @returns {string} The reversed string.
 */
export const reverseString = (string, stringSeparator) => {
  if (string && string.length > 1 && stringSeparator) {
    return string
      .split(stringSeparator)
      .reverse()
      .join(stringSeparator);
  }
  if (string && string.length > 1) {
    return string
      .split('')
      .reverse()
      .join('');
  }
  return string;
};

export const getOrdinalNumberCount = count => {
  const rules = new Intl.PluralRules(
    `${CONFIG.LANGUAGE}-${CONFIG.COUNTRY.toUpperCase()}`,
    {
      type: 'ordinal'
    }
  );
  const suffixes = new Map([
    ['zero', t('common.ordinalNumberCount_zero')],
    ['one', t('common.ordinalNumberCount_one')],
    ['two', t('common.ordinalNumberCount_two')],
    ['few', t('common.ordinalNumberCount_few')],
    ['many', t('common.ordinalNumberCount_many')],
    ['other', t('common.ordinalNumberCount_other')]
  ]);
  const formatOrdinals = n => {
    const rule = rules.select(n);
    const suffix = suffixes.get(rule);
    return `${n}${suffix}`;
  };
  return formatOrdinals(count);
};

export const decodeBase64 = string => {
  return window.atob(string);
};

export const capitalize = string => {
  if (typeof string !== 'string') {
    return '';
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const strongTextFunction = text => {
  const strongTextRegex = /<strong>(.*?)<\/strong>/g;
  const matches = [...text.matchAll(strongTextRegex)];
  if (matches.length === 0) {
    return text;
  }

  const splits = text.split(strongTextRegex);

  const strongs = splits.map((split, index) => {
    if (matches.some(match => match[1] === split)) {
      return <strong key={index}>{split}</strong>;
    }
    return split;
  });
  return strongs;
};
